<p-dialog
  [header]="'case.email.header' | translate"
  [(visible)]="showPopup"
  [modal]="true"
  [closable]="true"
  (onHide)="clearAll()"
  [style]="{ width: '75rem', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <div class="row modal-body">
    <div class="col-md-6">
      <div class="form-group">
        <label for="">{{ "case.email.template" | translate }}</label>
        <p-dropdown
          [options]="filteredTemplates"
          [(ngModel)]="selectedTemplate"
          [filter]="true"
          (ngModelChange)="onTemplateChange($event)"
          [placeholder]="'case.email.template-placeholder' | translate"
          optionLabel="templateName"
        >
        </p-dropdown>
      </div>

      <div>
        <div class="form-group">
          <label for="">{{ "case.email.receiver" | translate }}</label>
          <div class="email-chips" *ngIf="this.selectedTemplate">
            <div
              *ngFor="let email of receiverEmails"
              class="email-chip mb-2"
              [class.selected]="isReceiverEmailSelected(email)"
              (click)="toggleReceiverEmail(email)"
              role="button"  tabindex="-1"
            >
              {{ email }}
            </div>
          </div>
          <p-chips
            [allowDuplicate]="false"
            [(ngModel)]="selectedReceiverEmails"
            (onAdd)="handleChipAdd($event, 'receiver')"
          />
        </div>
      </div>
      <div>
        <div class="form-group">
          <label for="">{{ "case.email.cc" | translate }}</label>
          <div class="email-chips" *ngIf="this.selectedTemplate">
            <div
              *ngFor="let email of ccEmails"
              class="email-chip mb-2"
              [class.selected]="isCCEmailSelected(email)"
              (click)="toggleCCEmail(email)" role="button"  tabindex="-1"
            >
              {{ email }}
            </div>
          </div>
          <p-chips
            [allowDuplicate]="false"
            [(ngModel)]="selectedCCEmails"
            (onAdd)="handleChipAdd($event, 'cc')"
          />
        </div>
      </div>
      <div>
        <div class="container">
          <div class="upload-section">
            <h1>{{ "case.email.upload-file" | translate }}</h1>
            <div
              class="upload-box"
              (click)="fileInput.click()" role="button"  tabindex="-1"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              <input
                #fileInput
                type="file"
                (change)="onFileSelected($event)"
                style="display: none"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf,.xlsx,.xls,.doc,.docx"
              />
              <div class="upload-content">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                <p>{{ "case.email.upload-file-description" | translate }}</p>
                <small class="file-restrictions">
                  {{ "case.email.file-warning" | translate }}<br />
                  {{ "case.email.file-warning2" | translate }}
                </small>
              </div>
            </div>
            <div class="error-message" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
          </div>

          <div class="file-list-container" *ngIf="files.length > 0">
            <h2>{{ "case.email.uploaded-file" | translate }}</h2>
            <div class="file-list">
              <div class="file-item" *ngFor="let file of files; let i = index">
                <div class="file-info">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                    />
                    <polyline points="13 2 13 9 20 9" />
                  </svg>
                  <span>{{ file.name }}</span>
                  <small>{{ (file.size / 1024 / 1024).toFixed(2) }} MB</small>
                </div>
                <button class="delete-btn" (click)="removeFile(i)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="total-size">{{'case.email.total-size'}}: {{ getTotalSize() }} MB</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div>
        <div class="form-group">
          <label for="">{{ "case.email.bcc" | translate }}</label>
          <div class="email-chips" *ngIf="this.selectedTemplate">
            <div
              *ngFor="let email of bccEmails"
              class="email-chip mb-2"
              [class.selected]="isBCCEmailSelected(email)"
              (click)="toggleBCCEmail(email)" role="button"  tabindex="-1"
            >
              {{ email }}
            </div>
          </div>
          <p-chips
            [allowDuplicate]="false"
            [(ngModel)]="selectedBCCEmails"
            (onAdd)="handleChipAdd($event, 'bcc')"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="">{{ "case.email.mail-header" | translate }}</label>
        <app-readonly-input
          [value]="selectedTemplate?.emailTitle"
        ></app-readonly-input>
      </div>

      <div class="form-group">
        <label for="">{{ "case.email.mail-content" | translate }}</label>

        <p-editor
          id="contentEditor"
          [(ngModel)]="selectedContent"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
          [style]="{ height: '250px', width: '100%' }"
          [readonly]="true"
          [disabled]="true"
          [styleClass]="'readonly-editor'"
        ></p-editor>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="send-button" (click)="sendEmail()">
      {{ "common.send" | translate }}
    </button>
  </ng-template>
</p-dialog>
